import { createFieldHelper } from '@cks-internal/react-base';
import { NewUnverifiedHotelModel } from '../../../../../features/activities/hotelSearch/addHotel/types.ts';
import { useMemo, useState } from 'react';
import { maskitoMasks } from '../../../../../constants/maskitoMasks.ts';
import { ApiEndpoints } from '../../../../../constants/endpoints/apiEndpoints.ts';
import { ClickableText } from '../../../../../components/Common/ClickableText.tsx';
import { EmailRegex } from '../../../../../constants/EmailConstants.ts';
import { UseFormReturn } from 'react-hook-form';

export function useAddUnverifiedHotelFields(formMethods: UseFormReturn<NewUnverifiedHotelModel>) {
  const fieldHelper = createFieldHelper<NewUnverifiedHotelModel>(formMethods);
  const countryWatch = formMethods.watch('Address.CountryId');
  const provinceWatch = formMethods.watch('Address.ProvinceId');
  const [freeTextCity, setFreeTextCity] = useState(false);
  const isCanada = countryWatch == 1;

  return useMemo(() => {
    const mask = !isCanada ? maskitoMasks.zipCode : maskitoMasks.postalCode;

    return [
      fieldHelper.textInput('HotelName').withValidation({ required: {} }),

      fieldHelper
        .selectInputQueryItems('Address.CountryId', { searchUrl: ApiEndpoints.selectOptions.address.countries })
        .withValidation({ required: {} }),
      fieldHelper.textInput('Address.AddressLineOne'),
      fieldHelper.textInput('Address.AddressLineTwo'),
      fieldHelper
        .selectInputQueryItems('Address.ProvinceId', {
          searchUrl: ApiEndpoints.selectOptions.address.provinces(countryWatch),
          enabled: countryWatch != undefined
        })
        .withLabel(!isCanada ? 'State' : 'Province')
        .withValidation({ required: {} }),

      fieldHelper
        .selectInputQueryItems('Address.CityId', {
          searchUrl: ApiEndpoints.selectOptions.address.cities(provinceWatch),
          enabled: provinceWatch != undefined
        })
        .withRenderUnder(
          <ClickableText onClick={() => setFreeTextCity(true)}>
            Can't find the city? Clear here to enter it.
          </ClickableText>
        )
        .withRenderIf(() => !freeTextCity)
        .withValidation({ required: {} }),

      fieldHelper
        .textInput('Address.TemporaryCity')
        .withLabel('New City')
        .withRenderIf(() => freeTextCity)
        .withRenderUnder(
          <ClickableText onClick={() => setFreeTextCity(false)}>Click here to return to city list.</ClickableText>
        )
        .withValidation({ required: {} }),

      fieldHelper
        .textInput('Address.PostalZipCode')
        .withInputMask(mask)
        .withLabel(!isCanada ? 'Zip Code' : 'Postal Code'),

      fieldHelper
        .textInput('HotelEmail')
        .withValidation({
          pattern: {
            value: EmailRegex,
            message: 'Email address format must be valid.'
          }
        })
        .withPlaceholder('example@example.com'),
      fieldHelper
        .textInput('PaymentEmail')
        .withValidation({
          pattern: {
            value: EmailRegex,
            message: 'Email address format must be valid.'
          }
        })
        .withPlaceholder('example@example.com'),
      fieldHelper.textInput('PhoneNumber').withInputMask(maskitoMasks.phone),
      fieldHelper.textInput('FaxNumber').withInputMask(maskitoMasks.phone),
      fieldHelper.textInput('GdsId').withLabel('GDS Id'),
      fieldHelper.textInput('ChainCode'),
      fieldHelper.textInput('NonGdsId').withLabel('Non GDS Id'),
      fieldHelper.textArea('Notes')
    ];
  }, [countryWatch, provinceWatch, freeTextCity]);
}
